import { ImageCache } from './ImageCache';
import { Log } from '../../AuxillaryService/Log';
import { $ } from '../../../vendor/jquery';
import { shouldBeIgnored } from './Miscellaneous';

/**
 * Find and Replace Background Images with Cached URLs
 * @param {Node|Element} target
 * @private
 */
export function findAndReplaceBackgroundImages(target: HTMLElement): void {
    const className = 'bgimagecached';
    const selector =
        '[data-background-image]:not(img):not(.' +
        className +
        '), [style]:not(img):not(.' +
        className +
        ')';
    const elements = target.querySelectorAll<HTMLElement>(selector);
    const updateBackgroundUrl = function (element: HTMLElement): void {
        let urlMatches: RegExpMatchArray | null;
        let bgImageStyle: string | undefined;
        const findUrlsRegex = /(?:url\(['"]?)(.*?)(?:['"]?\))/g;
        const trimUrlRegex = /(^url\(["']?|["']?\)$)/g;
        const startsWithDataRegex = /^data:/i;
        const startsWithBlobRegex = /^blob:/i;
        const startsWithReachAssetRegex = /^reachasset:/i;
        const jqPromises: PromiseLike<string>[] = [];

        if (element.dataset && element.dataset.backgroundImage) {
            bgImageStyle = "url('" + element.dataset.backgroundImage + "')";
        } else if (element.style.backgroundImage) {
            bgImageStyle = element.style.backgroundImage;
        }

        if (bgImageStyle) {
            //multiple urls possible in css
            urlMatches = bgImageStyle.match(findUrlsRegex);

            if (urlMatches) {
                const bgUrls = urlMatches.join(';');

                urlMatches.forEach(function (cssURL) {
                    const url = cssURL.replace(trimUrlRegex, '');

                    if (
                        !startsWithDataRegex.test(url) &&
                        !startsWithBlobRegex.test(url) &&
                        !startsWithReachAssetRegex.test(url)
                    ) {
                        jqPromises.push(
                            ImageCache.getCached(url).fail(function (
                                xhr: XMLHttpRequest,
                                statusText: string,
                                msg: string,
                                event: Event
                            ) {
                                Log.Warning(
                                    'Failed to get cached background image: ' + url,
                                    null,
                                    __fileline,
                                    ImageCache.createPromiseFailObject(xhr, statusText, msg, event)
                                );
                            })
                        );
                    }
                });

                $.when(...jqPromises).done(function (...args) {
                    if (element.dataset.cacheUrl === bgUrls) {
                        // this image has already been cached and replaced, so
                        // don't do anything
                        return;
                    }

                    const cachedImages = typeof args[0] === 'string' ? [args] : args;

                    for (let idx = 0; idx < cachedImages.length; idx++) {
                        const cachedURL: string = cachedImages[idx][0];
                        const cssURL = (urlMatches as RegExpMatchArray)[idx];

                        // update background css
                        bgImageStyle = (bgImageStyle as string).replace(
                            cssURL,
                            'url(' + cachedURL + ')'
                        );
                    }

                    element.dataset.cacheUrl = bgUrls; // debugging
                    // update background css
                    element.style.backgroundImage = bgImageStyle as string;
                    element.classList.add(className);
                    $(element).show();
                });
            }
        }
    };

    // Update Element, ignore if the target has or is a child of an element with
    // the class .image-cache-ignore
    if (!shouldBeIgnored(target)) {
        if (target.matches(selector)) {
            updateBackgroundUrl(target);
        }
        // Update Element's Children
        for (let idx = 0; idx < elements.length; idx++) {
            //Ignore if the element has a parent with the class
            //.image-cache-ignore
            if (!shouldBeIgnored(elements[idx])) {
                updateBackgroundUrl(elements[idx]);
            }
        }
    }
}
